import styled from 'styled-components';
import { getColor } from '../../../../utils/theme';

export const StyledTitleMainCardSkeleton = styled.div`
  width: 100%;
  padding: 16px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: ${({ theme }) => {
    const color = getColor(theme.scheme.content.border, theme.palette);
    return `1px solid ${color};`;
  }};
`;

StyledTitleMainCardSkeleton.Caption = styled.div`
  border-radius: 3px;
  background: ${({ theme }) => {
    const color = getColor(theme.scheme.skeleton.background, theme.palette);

    return color;
  }};
`;